import { Flex, Icon, Modal, ModalBody, ModalContent, ModalOverlay, Text, GridItem, useMediaQuery } from '@chakra-ui/react'
import { ImPhoneHangUp } from 'react-icons/im'
import { useModalCallPhone } from '../../../contexts/CallPhoneContext'
import { useCallPhone } from '../../../hooks/useCallPhone'
import { FaArrowLeft } from 'react-icons/fa'
import { useState } from 'react'
import { useEffect } from 'react'
import { useCallback } from 'react'

export function Ligacao({ onClick }) {
  const [isLargerThan1366] = useMediaQuery('(max-width: 1366px)')

  return (
    <Flex gap="2" alignItems="center" onClick={onClick} cursor="pointer">
      <Flex
        alignItems="center"
        justifyContent="center"
        w="45px"
        h="45px"
        px="2"
        {...(isLargerThan1366 && { w: '35px', h: '35px' })}
        bg="white"
        borderRadius="100%"
      >
        <Icon as={ImPhoneHangUp} w={6} h={6} color="#e06f60" />
      </Flex>
      <Text as="span" color="gray.100" fontSize="15px" fontWeight="semibold">
        Iniciar Ligação
      </Text>
    </Flex>
  )
}

export function LigacaoModal() {
  const numbersTelephone = Array.from({ length: 9 }, (_, index) => index + 1)

  const {
    closeCallPhone: onClose,
    openCallPhone: onOpen,
    isOpen,
    numberPhone = '',
    handleNumberTelephone,
    clearNumberTelephone,
    deleteNumberTelephone,
  } = useModalCallPhone()

  console.log(numberPhone)

  const { callPhone } = useCallPhone()
  const [loadingCall, setLoadingCall] = useState(false)

  const handleCallPhone = useCallback(async () => {
    if (!numberPhone) {
      return
    }
    setLoadingCall(true)

    try {
      await callPhone(numberPhone)

      onClose()
    } catch (error) {
      setLoadingCall(false)
      console.log(error)
    }

    setLoadingCall(false)
  }, [callPhone, numberPhone, onClose])

  useEffect(() => {
    function handleKeyDown(event) {
      if (!isOpen) return

      const { key } = event

      if (key >= 0 && key <= 9) {
        handleNumberTelephone(String(key))
      }

      if (key === 'Backspace') {
        deleteNumberTelephone()
      }

      if (key === 'Escape') {
        clearNumberTelephone()
      }

      if (key === 'Enter') {
        handleCallPhone()
      }
    }

    window.addEventListener('keydown', handleKeyDown)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [handleNumberTelephone, deleteNumberTelephone, clearNumberTelephone, handleCallPhone])

  return (
    <>
      <Ligacao onClick={() => onOpen(numberPhone)} />
      <Modal isCentered onClose={onClose} isOpen={isOpen} motionPreset="slideInBottom" size="xs">
        <ModalOverlay />
        <ModalContent>
          <ModalBody display="grid" gridTemplateColumns="repeat(3, 1fr)" gap={3} placeItems="center">
            <GridItem colSpan={3} mt={10} position="relative">
              <Flex justifyContent="center" alignItems="center" h="60px">
                <Text as="span" color="#2D2D2D" fontSize="23px">
                  {numberPhone}
                </Text>
              </Flex>
              {loadingCall && (
                <Text position="absolute" bottom="0" left="50%" transform="translateX(-50%)" size="sm" color="#2D2D2D" fontSize="10px">
                  Chamando...
                </Text>
              )}
            </GridItem>

            {numbersTelephone.map((number) => (
              <Flex
                key={number}
                mt={5}
                justifyContent="center"
                alignItems="center"
                h="60px"
                w="60px"
                borderRadius="100%"
                bgColor={!loadingCall ? '#dddddd' : '#9b9b9b'}
                borderBottom="1px solid #E2E8F0"
                cursor="pointer"
                sx={{
                  '&:active': {
                    bgColor: '#E2E8F0',
                  },
                }}
                {...(loadingCall && {
                  //create
                  pointerEvents: 'none',
                  bgColor: '#9b9b9b',
                })}
                onClick={() => handleNumberTelephone(number)}
              >
                <Text as="span" color="#2D2D2D" fontSize="25px">
                  {number}
                </Text>
              </Flex>
            ))}
            <Flex
              mt={5}
              justifyContent="center"
              alignItems="center"
              h="60px"
              w="60px"
              borderRadius="100%"
              bgColor={!loadingCall ? '#dddddd' : '#9b9b9b'}
              borderBottom="1px solid #E2E8F0"
              cursor="pointer"
              {...(loadingCall && {
                //create
                pointerEvents: 'none',
                bgColor: '#9b9b9b',
              })}
              fontSize="25px"
              sx={{
                '&:active': {
                  bgColor: '#E2E8F0',
                },
              }}
              onClick={() => clearNumberTelephone()}
            >
              *
            </Flex>
            <Flex
              mt={5}
              justifyContent="center"
              alignItems="center"
              h="60px"
              w="60px"
              borderRadius="100%"
              bgColor={!loadingCall ? '#dddddd' : '#9b9b9b'}
              borderBottom="1px solid #E2E8F0"
              cursor="pointer"
              {...(loadingCall && {
                //create
                pointerEvents: 'none',
                bgColor: '#9b9b9b',
              })}
              fontSize="25px"
              sx={{
                '&:active': {
                  bgColor: '#E2E8F0',
                },
              }}
              onClick={() => handleNumberTelephone(0)}
            >
              0
            </Flex>
            <Flex
              mt={5}
              justifyContent="center"
              alignItems="center"
              h="60px"
              w="60px"
              borderRadius="100%"
              bgColor={!loadingCall ? '#dddddd' : '#9b9b9b'}
              borderBottom="1px solid #E2E8F0"
              cursor="pointer"
              fontSize="25px"
              {...(loadingCall && {
                //create
                pointerEvents: 'none',
                bgColor: '#9b9b9b',
              })}
              sx={{
                '&:active': {
                  bgColor: '#E2E8F0',
                },
              }}
              onClick={() => deleteNumberTelephone()}
            >
              <FaArrowLeft />
            </Flex>

            <GridItem colSpan={3} mt={3} mb="10">
              <Flex alignItems="center" justifyContent="center" gap={10}>
                <Flex
                  justifyContent="center"
                  alignItems="center"
                  h="60px"
                  w="60px"
                  borderRadius="100%"
                  bgColor="#95C620"
                  {...(loadingCall && {
                    pointerEvents: 'none',
                    bgColor: '#9b9b9b',
                  })}
                  cursor="pointer"
                  onClick={handleCallPhone}
                >
                  <Icon as={ImPhoneHangUp} w={10} h={10} color="white" />
                </Flex>
              </Flex>
            </GridItem>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}
